export enum AdminRuntimeEnvProfile {
  Inherit = 'inherit',
  Development = 'development',
  Staging = 'staging',
  Production = 'production',
  Custom = 'custom',
}
